import '../style.css';
import { mountWavebeanGame } from './game';

mountWavebeanGame();
